import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "text-body-large font-weight-bold mb-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-body-medium font-weight-bold mb-4" }
const _hoisted_4 = { class: "text-body-small mb-4" }
const _hoisted_5 = { class: "text-body-medium font-weight-bold mb-4" }
const _hoisted_6 = { class: "text-body-small mb-4" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "text-title-small mb-2"
}
const _hoisted_9 = {
  key: 1,
  class: "braille-loader wave-style text-primary"
}
const _hoisted_10 = {
  key: 0,
  style: {"white-space":"pre-wrap"}
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "text-body-medium font-weight-bold mb-2" }
const _hoisted_13 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_14 = { class: "text-body-medium font-weight-bold mb-1" }
const _hoisted_15 = { class: "d-flex align-center gap-2 mt-1" }
const _hoisted_16 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "800px",
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between bg-primary" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.t('title')), 1),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "7",
                    class: _normalizeClass(_ctx.$vuetify.display.xs ? 'text-body-medium' : '')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.t('description1')), 1),
                      (_ctx.$vuetify.display.xs)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: require(`@/assets/disa-chat-picture.png`),
                            width: "240",
                            round: ""
                          }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('description2')), 1),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('description3')), 1),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('description4')), 1),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('description5')), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (!_ctx.$vuetify.display.xs)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "5"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: require(`@/assets/disa-chat-picture.png`),
                            width: "330",
                            round: ""
                          }, null, 8, _hoisted_7)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "10"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.question,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.question) = $event)),
                        label: _ctx.t('question'),
                        density: "comfortable",
                        variant: "outlined",
                        onKeyup: _withKeys(_ctx.testLlm, ["enter"])
                      }, null, 8, ["modelValue", "label", "onKeyup"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: _normalizeClass(_ctx.$vuetify.display.xs ? 'mt-n8' : ''),
                        height: "48",
                        block: "",
                        variant: "flat",
                        color: "primary",
                        loading: _ctx.loading,
                        onClick: _ctx.testLlm
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('send')), 1)
                        ]),
                        _: 1
                      }, 8, ["class", "loading", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Answering..."))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("span", null, "⡀⣀⣄⣤⣦⣷⣿⣷⣴⣦⣤⣄⣀⡀⡀⣀⣄⣤⣦⣷⣿⣷⣴⣦⣤⣄⣀⡀", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_ctx.answer)
                ? (_openBlock(), _createBlock(_component_v_sheet, {
                    key: 2,
                    variant: "outlined",
                    rounded: "",
                    class: _normalizeClass(["pa-4 mt-2", [
            { 'markdown-body': !_ctx.loading },
            _ctx.$vuetify.display.xs ? 'text-body-medium' : '',
          ]])
                  }, {
                    default: _withCtx(() => [
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.answer), 1))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            innerHTML: _ctx.answerHtml
                          }, null, 8, _hoisted_11))
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true),
              (_ctx.answer && !_ctx.loading)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 3,
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "7" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('feedbackTitle')), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(
                _ctx.$vuetify.display.xs
                  ? 'd-flex flex-column ga-2 align-start'
                  : 'd-flex ga-2 align-start'
              )
                          }, [
                            _createVNode(_component_v_btn, {
                              variant: "text",
                              density: "compact",
                              class: _normalizeClass({ 'feedback-quality-selected': _ctx.selectedQuality === 1 }),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectQuality(1)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  color: "success",
                                  size: "small",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                    _createTextVNode("mdi-circle", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.t('feedbackGood')), 1)
                              ]),
                              _: 1
                            }, 8, ["class"]),
                            _createVNode(_component_v_btn, {
                              variant: "text",
                              density: "compact",
                              class: _normalizeClass({ 'feedback-quality-selected': _ctx.selectedQuality === 2 }),
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectQuality(2)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  color: "warning",
                                  size: "small",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                    _createTextVNode("mdi-circle", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.t('feedbackSoSo')), 1)
                              ]),
                              _: 1
                            }, 8, ["class"]),
                            _createVNode(_component_v_btn, {
                              variant: "text",
                              density: "compact",
                              class: _normalizeClass({ 'feedback-quality-selected': _ctx.selectedQuality === 3 }),
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectQuality(3)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  color: "error",
                                  size: "small",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                    _createTextVNode("mdi-circle", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.t('feedbackBad')), 1)
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ], 2),
                          (_ctx.selectedQuality === 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('feedbackWhyTitle')), 1),
                                _createVNode(_component_v_checkbox, {
                                  modelValue: _ctx.selectedTypes,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTypes) = $event)),
                                  value: 1,
                                  label: _ctx.t('feedbackAnswerUnclear'),
                                  density: "compact",
                                  "hide-details": "",
                                  class: "mb-1"
                                }, null, 8, ["modelValue", "label"]),
                                _createVNode(_component_v_checkbox, {
                                  modelValue: _ctx.selectedTypes,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTypes) = $event)),
                                  value: 2,
                                  label: _ctx.t('feedbackTooFewDetails'),
                                  density: "compact",
                                  "hide-details": "",
                                  class: "mb-1"
                                }, null, 8, ["modelValue", "label"]),
                                _createVNode(_component_v_checkbox, {
                                  modelValue: _ctx.selectedTypes,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedTypes) = $event)),
                                  value: 3,
                                  label: _ctx.t('feedbackNotHelpful'),
                                  density: "compact",
                                  "hide-details": "",
                                  class: "mb-1"
                                }, null, 8, ["modelValue", "label"]),
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.selectedTypes,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedTypes) = $event)),
                                    value: 4,
                                    label: _ctx.t('feedbackOther') + ':',
                                    density: "compact",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue", "label"]),
                                  (_ctx.selectedTypes.includes(4))
                                    ? (_openBlock(), _createBlock(_component_v_text_field, {
                                        key: 0,
                                        modelValue: _ctx.feedbackDetails,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.feedbackDetails) = $event)),
                                        variant: "underlined",
                                        density: "compact",
                                        "hide-details": "",
                                        style: {"min-width":"180px"}
                                      }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.selectedQuality && !_ctx.feedbackSent)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                color: "success",
                                class: "mt-3",
                                loading: _ctx.feedbackLoading,
                                onClick: _ctx.submitFeedback
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('feedbackSend')), 1)
                                ]),
                                _: 1
                              }, 8, ["loading", "onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "5",
                        class: "d-flex flex-column align-center"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: require(`@/assets/disa-feedback.png`),
                            width: "180"
                          }, null, 8, _hoisted_16),
                          (_ctx.feedbackSent)
                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                key: 0,
                                type: "success",
                                variant: "tonal",
                                class: "mt-2 w-100 text-center font-weight-bold"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('feedbackThankYou')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}